export const URL = {
	REDIRECT: "https://sgio.univasf.edu.br/",

	// Alterar caso em DEV ou Produção
	//
	//
	// AXIOS_BASE_URL: 'http://127.0.0.1:8000/',
	AXIOS_BASE_URL: "https://sgio.univasf.edu.br/",

	MANAGEMENT: {
		GET_USERS_ADMIN: "/admin/users/",
		DELETE_USER: "/user/",
		TOGGLE_DEACTIVATE_USER: "/toggle/user/",
	},

	RESULT: {
		POST_RESULT: "/result/",
		GET_RESULTS: "/results/",
		GET_RESULT_BY_ID: "/result/",
	},

	REGISTRATION: {
		WITHOUT_ORG: "/registration/",
		WITH_ORG: "/org/registration/",
		POST_USER_ADMIN: "/admin/registration/",
	},

	PROFILE: {
		VIEW: "/profile/",
		EDIT_PROFILE: "/edit/profile/",
	},

	AUTH: {
		CHANGE_PASSWORD: "/auth/users/set_password/",
		POST_LOGIN: "/auth/login/",
		RESET_PASSWORD: "auth/users/reset_password/",
		RESET_PASSWORD_CONFIRM: "/auth/users/reset_password_confirm/",
	},
};
